import { render, staticRenderFns } from "./PaletteView.vue?vue&type=template&id=c50f2c0a&scoped=true"
import script from "./PaletteView.vue?vue&type=script&lang=js"
export * from "./PaletteView.vue?vue&type=script&lang=js"
import style0 from "./PaletteView.vue?vue&type=style&index=0&id=c50f2c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50f2c0a",
  null
  
)

export default component.exports